import React from "react";

// logo
import Logo from "../assets/img/logo-white.svg";

// data
import { social } from "../data";

const Footer = () => {
  return (
    <footer className="bg-orange py-8 lg:py-4">
      <div className="container mx-auto">
        <div className="flex text-white flex-col gap-y-6 lg:flex-row items-center justify-between">

          <a href="/">
            <img src={Logo} alt="Logo" className="w-[125px]" />
          </a>

        <div className="text-[15px]">
          &copy; Direitos Reservados, 2023.
        </div>


        </div>
      </div>
    </footer>
  );
};

export default Footer;
